import React from 'react';
import { Button } from '@mui/material';
import { FileDownload as FileDownloadIcon } from '@mui/icons-material';
import { useDownloadWriteOffCandidatesMutation } from '../../../../services/AccountService';
import { WriteOffCandidatesRequest } from '../../../../services/AccountService/requests/writeOffCandidatesRequest';

interface WriteOffCandidatesDownloadCsvProps {
  /** The filters the grid is showing. The export must select the same accounts. */
  filters: WriteOffCandidatesRequest;
}

const WriteOffCandidatesDownloadCsv: React.FC<WriteOffCandidatesDownloadCsvProps> = ({ filters }) => {
  const centerId = filters.centerId;
  const [downloadWriteOffCandidates, { isLoading: isDownloading }] = useDownloadWriteOffCandidatesMutation();

  const handleDownload = async () => {
    if (!centerId) {
      console.warn('Center ID is required for download');
      return;
    }

    try {
      const blob = await downloadWriteOffCandidates(filters).unwrap();

      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `WriteOffCandidates_${centerId}_${new Date().toISOString().slice(0, 10)}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err: any) {
      console.error('Download failed:', err);
    }
  };

  return (
    <Button
      variant="outlined"
      startIcon={<FileDownloadIcon />}
      onClick={handleDownload}
      disabled={!centerId || isDownloading}
      size="small"
      sx={{
        borderColor: '#3b82f6',
        color: '#3b82f6',
        '&:hover': {
          borderColor: '#2563eb',
          backgroundColor: 'rgba(59, 130, 246, 0.04)',
        },
      }}
    >
      {isDownloading ? 'Exporting...' : 'Export CSV'}
    </Button>
  );
};

export default WriteOffCandidatesDownloadCsv;
